import { render, staticRenderFns } from "./ViewAcademies.vue?vue&type=template&id=292f02d5&scoped=true"
import script from "./ViewAcademies.vue?vue&type=script&lang=js"
export * from "./ViewAcademies.vue?vue&type=script&lang=js"
import style0 from "./ViewAcademies.vue?vue&type=style&index=0&id=292f02d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292f02d5",
  null
  
)

export default component.exports